export const DEFAULT_UI_LIBRARY = 'antd';

export const DEFAULT_ICON = 'https://vfiles.gtimg.cn/vupload/20210813/7e35b01628823110001.png';
